import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { Ge as g, hi as v, di as f, M as p } from "./abstract-base-8edf0a84-e11d45a3.js";
import { i as m } from "./query-24926cff-3eb94bfb.js";
import { _t as w, Ia as y, be as C, qa as D, Qa as L, St as $ } from "./chart-base-ecca78b9-a6ec3103.js";
import { n as M } from "./breakpoints-1ea07f11-d0da757c.js";
import { M as b } from "./scale-8b395353-27d44d00.js";
import { o as u } from "./chart-tooltip.constants-f76f46e6-1f185240.js";
import { o as T, n as x } from "./variables-37cba309-153935bd.js";
import "./chart-base.helpers-722f3948-fa82acec.js";
import "./unsafe-svg-8b07bc77-f986d223.js";
import "./utils-2e24a437-383bbd0f.js";
import "./state-b4c9cc73-ee633f6c.js";
import "./map-7910a3a7-389c4b7b.js";
import "./chart-tooltip-e4995844-42c7681e.js";
import "./legend-5216905c-c7014324.js";
import "./legend-circle-0e9cbc84-7a23b644.js";
import "./directive-daf4e9b6-abc0af54.js";
var d = /* @__PURE__ */function (s) {
  return s.VALUE = "value", s.PERCENTAGE = "percentage", s;
}(d || {});
var a = {
    beaconTagName: "beacon-donut-chart",
    pieSizePercentage: "80%",
    percentageWidth: 0.64,
    distanceNumber: 4,
    drilldownName: "has-drilldown",
    drilldownActiveName: "is-drilldown",
    monoColorName: "mono-color",
    inactiveDataLabelClass: "data-label--inactive",
    minimumSizeJumbo: T,
    minimumSizeDefault: x,
    maxLabelIndexSmallBreakpoint: 3,
    maxLabelAngle: 4,
    defaultLabelDistance: 10,
    transparentConnectorClass: "transparent-connector",
    tooltipOrientation: "vertical",
    attributes: {
      metricTotal: "metric-total",
      metricDescription: "metric-description",
      hideChartMetric: "hide-chart-metric",
      tooltipFormat: "tooltip-format",
      startingAngle: "starting-angle"
    },
    properties: {
      metricTotal: "metricTotal",
      metricDescription: "metricDescription",
      hideChartMetric: "hideChartMetric",
      tooltipFormat: "tooltipFormat",
      scale: "scale",
      series: "series"
    },
    metricWrapperClass: "metric-wrapper",
    highchartsDataLabelConnectorClass: "highchart-data-label-connector",
    highchartsColorClass: "highcharts-color",
    highchartsDataLabelClass: "highcharts-data-label",
    tooltipID: "chart-custom-tooltip"
  },
  E = g(_templateObject || (_templateObject = _taggedTemplateLiteral([".chart--pie .metric-wrapper{display:var(--beacon-donut-chart-metric-display, block);inline-size:var(--metric-total-inline-size);overflow:hidden;text-align:center;white-space:initial;word-break:break-word}.chart--pie .metric-wrapper p{margin:0}.chart--pie .metric-wrapper .metric-total{font-size:var(--metric-font-size);font-weight:var(--beacon-font-weight-bold);line-height:var(--metric-line-height)}.chart--pie .metric-wrapper.normal{--metric-font-size: var(--beacon-donut-chart-metric-font-size-normal);--metric-line-height: var(--beacon-donut-chart-metric-font-line-height-normal)}.chart--pie .metric-wrapper.mini{--metric-font-size: var(--beacon-donut-chart-metric-font-size-mini);--metric-line-height: var(--beacon-donut-chart-metric-font-line-height-mini)}.chart--pie .metric-wrapper.jumbo{--metric-font-size: var(--beacon-donut-chart-metric-font-size-jumbo);--metric-line-height: var(--beacon-donut-chart-metric-font-line-height-jumbo)}.chart--pie .metric-wrapper .metric-description{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-headline-100, var(--beacon-headline-font-size-100)/var(--beacon-headline-font-line-height-module-100) var(--beacon-font-family-default))}.chart--pie .highcharts-data-label{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.chart--pie .highcharts-data-label text{fill:var(--beacon-color-text-default)}.chart--pie .highcharts-breadcrumbs-button text{font-size:var(--beacon-button-font-size-normal);line-height:var(--beacon-button-font-line-height-normal);fill:var(--beacon-color-cta-text-tertiary-default)}.chart--pie .highcharts-data-label-connector{fill:none;stroke:var(--beacon-colors-light-grey-1)}.chart--pie .highcharts-point{stroke:var(--beacon-donut-chart-point-color)}.chart--pie .highcharts-point.highcharts-point-hover{fill-opacity:100%}.chart--pie .highcharts-drilldown-data-label{color:var(--beacon-color-hyperlink-default);cursor:pointer}.chart--pie .highcharts-drilldown-data-label :first-child{text-decoration:underline}.chart--pie .highcharts-drilldown-data-label text{fill:var(--beacon-color-hyperlink-default)}.chart--pie .transparent-connector.highcharts-data-label-connector{stroke:transparent}.chart--pie.has-drilldown+.legend-container [data-legend-item=drilldown]{display:none}.chart--pie.is-drilldown+.legend-container [data-legend-item=primary]{display:none}.chart--pie.deselected .metric-wrapper{display:none}.base.mono-color-dark-blue{--beacon-chart-override-drilldown-series-color-0: var(--beacon-donut-chart-color-dark-blue-1);--beacon-chart-override-drilldown-series-color-1: var(--beacon-donut-chart-color-dark-blue-2);--beacon-chart-override-drilldown-series-color-2: var(--beacon-donut-chart-color-dark-blue-3);--beacon-chart-override-drilldown-series-color-3: var(--beacon-donut-chart-color-dark-blue-4);--beacon-chart-override-drilldown-series-color-4: var(--beacon-donut-chart-color-dark-blue-5)}.base.mono-color-dark-blue .highcharts-color-0{fill:var(--beacon-donut-chart-color-dark-blue-1)}.base.mono-color-dark-blue .highcharts-color-1{fill:var(--beacon-donut-chart-color-dark-blue-2)}.base.mono-color-dark-blue .highcharts-color-2{fill:var(--beacon-donut-chart-color-dark-blue-3)}.base.mono-color-dark-blue .highcharts-color-3{fill:var(--beacon-donut-chart-color-dark-blue-4)}.base.mono-color-dark-blue .highcharts-color-4{fill:var(--beacon-donut-chart-color-dark-blue-5)}.base.mono-color-teal{--beacon-chart-override-drilldown-series-color-0: var(--beacon-donut-chart-color-teal-1);--beacon-chart-override-drilldown-series-color-1: var(--beacon-donut-chart-color-teal-2);--beacon-chart-override-drilldown-series-color-2: var(--beacon-donut-chart-color-teal-3);--beacon-chart-override-drilldown-series-color-3: var(--beacon-donut-chart-color-teal-4);--beacon-chart-override-drilldown-series-color-4: var(--beacon-donut-chart-color-teal-5)}.base.mono-color-teal .highcharts-color-0{fill:var(--beacon-donut-chart-color-teal-1)}.base.mono-color-teal .highcharts-color-1{fill:var(--beacon-donut-chart-color-teal-2)}.base.mono-color-teal .highcharts-color-2{fill:var(--beacon-donut-chart-color-teal-3)}.base.mono-color-teal .highcharts-color-3{fill:var(--beacon-donut-chart-color-teal-4)}.base.mono-color-teal .highcharts-color-4{fill:var(--beacon-donut-chart-color-teal-5)}.base.mono-color-purple{--beacon-chart-override-drilldown-series-color-0: var(--beacon-donut-chart-color-purple-1);--beacon-chart-override-drilldown-series-color-1: var(--beacon-donut-chart-color-purple-2);--beacon-chart-override-drilldown-series-color-2: var(--beacon-donut-chart-color-purple-3);--beacon-chart-override-drilldown-series-color-3: var(--beacon-donut-chart-color-purple-4);--beacon-chart-override-drilldown-series-color-4: var(--beacon-donut-chart-color-purple-5)}.base.mono-color-purple .highcharts-color-0{fill:var(--beacon-donut-chart-color-purple-1)}.base.mono-color-purple .highcharts-color-1{fill:var(--beacon-donut-chart-color-purple-2)}.base.mono-color-purple .highcharts-color-2{fill:var(--beacon-donut-chart-color-purple-3)}.base.mono-color-purple .highcharts-color-3{fill:var(--beacon-donut-chart-color-purple-4)}.base.mono-color-purple .highcharts-color-4{fill:var(--beacon-donut-chart-color-purple-5)}.base.mono-color-berry{--beacon-chart-override-drilldown-series-color-0: var(--beacon-donut-chart-color-berry-1);--beacon-chart-override-drilldown-series-color-1: var(--beacon-donut-chart-color-berry-2);--beacon-chart-override-drilldown-series-color-2: var(--beacon-donut-chart-color-berry-3);--beacon-chart-override-drilldown-series-color-3: var(--beacon-donut-chart-color-berry-4);--beacon-chart-override-drilldown-series-color-4: var(--beacon-donut-chart-color-berry-5)}.base.mono-color-berry .highcharts-color-0{fill:var(--beacon-donut-chart-color-berry-1)}.base.mono-color-berry .highcharts-color-1{fill:var(--beacon-donut-chart-color-berry-2)}.base.mono-color-berry .highcharts-color-2{fill:var(--beacon-donut-chart-color-berry-3)}.base.mono-color-berry .highcharts-color-3{fill:var(--beacon-donut-chart-color-berry-4)}.base.mono-color-berry .highcharts-color-4{fill:var(--beacon-donut-chart-color-berry-5)}.base.mono-color-orange{--beacon-chart-override-drilldown-series-color-0: var(--beacon-donut-chart-color-orange-1);--beacon-chart-override-drilldown-series-color-1: var(--beacon-donut-chart-color-orange-2);--beacon-chart-override-drilldown-series-color-2: var(--beacon-donut-chart-color-orange-3);--beacon-chart-override-drilldown-series-color-3: var(--beacon-donut-chart-color-orange-4);--beacon-chart-override-drilldown-series-color-4: var(--beacon-donut-chart-color-orange-5)}.base.mono-color-orange .highcharts-color-0{fill:var(--beacon-donut-chart-color-orange-1)}.base.mono-color-orange .highcharts-color-1{fill:var(--beacon-donut-chart-color-orange-2)}.base.mono-color-orange .highcharts-color-2{fill:var(--beacon-donut-chart-color-orange-3)}.base.mono-color-orange .highcharts-color-3{fill:var(--beacon-donut-chart-color-orange-4)}.base.mono-color-orange .highcharts-color-4{fill:var(--beacon-donut-chart-color-orange-5)}.base.mono-color-grey{--beacon-chart-override-drilldown-series-color-0: var(--beacon-donut-chart-color-grey-1);--beacon-chart-override-drilldown-series-color-1: var(--beacon-donut-chart-color-grey-2);--beacon-chart-override-drilldown-series-color-2: var(--beacon-donut-chart-color-grey-3);--beacon-chart-override-drilldown-series-color-3: var(--beacon-donut-chart-color-grey-4);--beacon-chart-override-drilldown-series-color-4: var(--beacon-donut-chart-color-grey-5)}.base.mono-color-grey .highcharts-color-0{fill:var(--beacon-donut-chart-color-grey-1)}.base.mono-color-grey .highcharts-color-1{fill:var(--beacon-donut-chart-color-grey-2)}.base.mono-color-grey .highcharts-color-2{fill:var(--beacon-donut-chart-color-grey-3)}.base.mono-color-grey .highcharts-color-3{fill:var(--beacon-donut-chart-color-grey-4)}.base.mono-color-grey .highcharts-color-4{fill:var(--beacon-donut-chart-color-grey-5)}\n"])));
var N = Object.defineProperty,
  z = Object.getOwnPropertyDescriptor,
  n = function n(s, r, e, o) {
    for (var t = o > 1 ? void 0 : o ? z(r, e) : r, i = s.length - 1, c; i >= 0; i--) (c = s[i]) && (t = (o ? c(r, e, t) : c(t)) || t);
    return o && t && N(r, e, t), t;
  };
var l = /*#__PURE__*/function (_v) {
  _inherits(l, _v);
  function l() {
    var _this;
    _classCallCheck(this, l);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(l).apply(this, arguments)), _this.beaconTagName = a.beaconTagName, _this.metricTotal = "", _this.metricDescription = "", _this.scale = b.NORMAL, _this.hideChartMetric = !1, _this.tooltipFormat = d.VALUE, _this.monoClassName = "", _this.drilldownItemData = [];
    return _this;
  }
  _createClass(l, [{
    key: "createLegend",
    /**
     * Initializes the chartLoadedSeries object from the chart emitted when
     * the chart loads, and uses the results to render a legend and legend-item
     * @param chart the chart object used to build the data-visualization
     */
    value: function createLegend(r) {
      var _this2 = this;
      r && (this.staticLegend = !0, this.chartLoadedSeries = r.series[0].data.map(function (e, o) {
        return {
          name: e.name,
          index: o,
          value: _this2.getLegendValue(e)
        };
      }));
    }
    /**
     * Generate Legend Value based on toltipFormat
     * @param series Highchart Series
     * @returns percentage as string if tooltipForrmat is percentage otherwise will return value
     */
  }, {
    key: "getLegendValue",
    value: function getLegendValue(r) {
      return this.tooltipFormat === d.PERCENTAGE ? "".concat(Math.round(r.percentage), "%") : r.y || "";
    }
    /**
     * On Chart Load called on load event callback. Adds Metric Text and discription after chart load.
     * @param chart Highcharts.Chart
     */
  }, {
    key: "onChartLoad",
    value: function () {
      var _onChartLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(r) {
        var e;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = r;
              if (!_context.t0) {
                _context.next = 8;
                break;
              }
              this.chart = r;
              _context.next = 5;
              return this.sortData();
            case 5:
              this.createLegend(r);
              this.hideChartMetric || this.createChartMetric(r);
              (e = this.drilldownSeries) != null && e.length && this.chartContainer.classList.add(a.drilldownName);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onChartLoad(_x) {
        return _onChartLoad.apply(this, arguments);
      }
      return onChartLoad;
    }()
  }, {
    key: "sortData",
    value: function () {
      var _sortData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var r, e;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.chart && (this.chart.update({
                plotOptions: {
                  series: {
                    dataSorting: {
                      enabled: !0
                    }
                  }
                }
              }, !0), this.series))) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return this.updateComplete;
            case 3:
              e = this.series[0].data;
              e && (e = e.sort(function (o, t) {
                return t.y - o.y;
              }), (r = this.chart) == null || r.series[0].setData(JSON.parse(JSON.stringify(e))));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function sortData() {
        return _sortData.apply(this, arguments);
      }
      return sortData;
    }()
    /**
     * Creates the chart metric and places it in the center of the chart.
     * @param chart Highcharts.Chart
     */
  }, {
    key: "createChartMetric",
    value: function createChartMetric(r) {
      var e;
      this.metricWrapper && ((e = this.metricWrapper.parentElement) == null || e.remove());
      var o = r.series[0].total;
      if (o && (this.metricTotal = o == null ? void 0 : o.toFixed(0)), this.metricTotal) {
        var _this$getCenterElemen = this.getCenterElementAxes(r),
          t = _this$getCenterElemen.x,
          i = _this$getCenterElemen.y,
          c = _this$getCenterElemen.metricTotalInlineSize,
          h = "<div class=\"".concat(a.metricWrapperClass, " ").concat(this.scale, "\">\n      <style>.").concat(a.metricWrapperClass, "{--metric-total-inline-size: ").concat(c, ";}</style>\n          <p class=\"").concat(a.attributes.metricTotal, "\" aria-describedby=\"").concat(a.attributes.metricDescription, "\">\n            ").concat(this.metricTotal, "\n          </p>\n          <p class=\"").concat(a.attributes.metricDescription, "\" id=\"").concat(a.attributes.metricDescription, "\">\n            ").concat(this.metricDescription, "\n          </p> \n        </div>");
        this.createCenterElement(r, h, t, i), this.positionMetricElement(r, t, i);
      }
    }
    /**
     * On Resizes updates the center text element of the chart.
     * @param chart Highcharts.Chart
     */
  }, {
    key: "onChartRedraw",
    value: function onChartRedraw(r) {
      var _this$getCenterElemen2 = this.getCenterElementAxes(r),
        e = _this$getCenterElemen2.x,
        o = _this$getCenterElemen2.y;
      this.positionMetricElement(r, e, o);
    }
    /**
     * Pass the Chart and cordinates where metricElement can be added.
     * @param chart Highcharts.chart
     * @param x number
     * @param y number
     */
  }, {
    key: "positionMetricElement",
    value: function positionMetricElement(r, e, o) {
      if (r && r.pieCenter) {
        var t = r.pieCenter.getBBox();
        r.pieCenter.attr({
          x: e - t.width / 2,
          y: o - t.height / 4
        });
      }
    }
    /**
     * Creates metric Element in the chart using chart.renderer()
     * @param chart Highcharts.chart
     * @param El string of the HTML
     * @param x number
     * @param y number
     */
  }, {
    key: "createCenterElement",
    value: function createCenterElement(r, e, o, t) {
      r && (r.pieCenter = r.renderer.text("".concat(e), o, t, !0).add());
    }
    /**
     * Returns Center Element cordinates and inline-size.
     * @param chart HighCharts.chart
     * @returns x, y, inlineSize
     */
  }, {
    key: "getCenterElementAxes",
    value: function getCenterElementAxes(r) {
      var e, o, t;
      if (r && r.series && r.series.length) {
        var i = r.series[0];
        i && i.center && (e = r.plotLeft + i.center[0], o = r.plotTop - 10 + i.center[1], t = "".concat(i.center[2] * a.percentageWidth, "px"));
      }
      return {
        x: e,
        y: o,
        metricTotalInlineSize: t
      };
    }
    /**
     * on Drilldown changing style of the piechart. Adding MonoColor styles.
     * @param chart DrilldownEventObject
     */
  }, {
    key: "onDrilldown",
    value: function onDrilldown(r) {
      var _this3 = this;
      var e, o;
      if (r) {
        if (this.drilldownItemData.length === 0) {
          this.drilldownItemData = (o = (e = r.seriesOptions) == null ? void 0 : e.data) == null ? void 0 : o.map(function (i, c) {
            return {
              name: i[0],
              index: c,
              value: _this3.getDrilldownLegendValue(r.seriesOptions.data, i[1])
            };
          });
          var t = this.drilldownItemData.map(function (i) {
            return "<".concat(_this3.getScopedTagName("beacon-legend-item"), " data-legend-item=\"drilldown\" label=").concat(i.name, " index=").concat(i.index, " value=").concat(_this3.hideLegendMetric ? "" : i.value, "></").concat(_this3.getScopedTagName("beacon-legend-item"), ">");
          });
          this.legend.innerHTML += t.join("");
        }
        this.updateMonoColor(r), this.chartContainer.classList.contains(a.drilldownName) && (this.chartContainer.classList.remove(a.drilldownName), this.chartContainer.classList.add(a.drilldownActiveName));
      }
    }
    /**
     * onDrilldown based on tooltipFormat returns percentage or value.
     * @param data Series Data
     * @param currentSeriesVal Current Series Va;ue
     * @returns percentage as string if tooltipForrmat is percentage otherwise will return value
     */
  }, {
    key: "getDrilldownLegendValue",
    value: function getDrilldownLegendValue(r, e) {
      var o;
      if (this.tooltipFormat === d.PERCENTAGE) {
        var t = r.reduce(function (c, h) {
            return c + h[1];
          }, 0) || 0,
          i = e * 100 / t;
        o = "".concat(Math.round(i), "%");
      } else o = e;
      return o;
    }
    /**
     * On Drillup, removing Monocolor styles.
     * @param chart DrillupEventObject
     */
  }, {
    key: "onDrillup",
    value: function onDrillup(r) {
      var e;
      r && (this.removeMonoColor(), (e = this.drilldownSeries) != null && e.length && (this.chartContainer.classList.add(a.drilldownName), this.chartContainer.classList.remove(a.drilldownActiveName)));
    }
    /**
     * Adding Monocolor styles.
     * @param chart DrilldownEventObject
     */
  }, {
    key: "updateMonoColor",
    value: function updateMonoColor(r) {
      var e = r.point;
      if (e) {
        var o = e.colorIndex || 0;
        var t,
          i = "";
        this.colorOrder === C.FULL ? t = D() : t = L(), o >= 0 && t && (i = t[o], this.monoClassName = "".concat(a.monoColorName, "-").concat(i), this.baseElement.classList.add("".concat(a.monoColorName, "-").concat(i)));
      }
    }
    /**
     * Logic to remove monocolor styles.
     */
  }, {
    key: "removeMonoColor",
    value: function removeMonoColor() {
      this.baseElement.classList.contains(this.monoClassName) && this.baseElement.classList.remove(this.monoClassName);
    }
    /**
     * Calls the highcharts show function on the input series index.
     *
     * Overrides base.
     *
     * @param index the index of the chart series to be shown
     */
  }, {
    key: "showSeries",
    value: function showSeries(r) {
      var e;
      (e = this.chart) == null || e.series[0].data[r].setVisible(!0);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      var r;
      (r = this.handleDefer()) == null || r.then(function () {
        _get(_getPrototypeOf(l.prototype), "connectedCallback", _this4).call(_this4);
      });
    }
  }, {
    key: "willUpdate",
    value: function willUpdate(r) {
      var e;
      (r.has(a.properties.metricTotal) && this.metricTotalElement || r.has(a.properties.metricDescription) && this.metricDescriptionElement) && this.createChartMetric(this.chart), r.has(a.properties.hideChartMetric) && (this.hideChartMetric && this.metricWrapper ? (e = this.metricWrapper.parentElement) == null || e.remove() : !this.hideChartMetric && !this.metricWrapper && this.chart && this.createChartMetric(this.chart)), r.has(a.properties.scale) && this.metricWrapper && this.scale && (this.metricWrapper.classList.remove(r.get(a.properties.scale)), this.metricWrapper.classList.add(this.scale)), r.has(a.properties.tooltipFormat) && this.chart && this.createLegend(this.chart), r.has(a.properties.series) && this.chart && this.onChartLoad(this.chart), _get(_getPrototypeOf(l.prototype), "willUpdate", this).call(this, r);
    } /* overrides default render to display donut chart with beacon-chart-tooltip */
  }, {
    key: "render",
    value: function render() {
      return f(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<div class=\"chart-and-tooltip-wrapper\">", "\n    <", " id=", " orientation=", "></", "></div>"])), _get(_getPrototypeOf(l.prototype), "render", this).call(this), this.getScopedTag(u.beaconTagName), a.tooltipID, a.tooltipOrientation, this.getScopedTag(u.beaconTagName));
    }
  }, {
    key: "type",
    /**
     * Setting ChartType to Pie
     */
    get: function get() {
      return w.PIE;
    }
    /**
     * Setting Series length in chart-base, will return boolean.
     */
  }, {
    key: "seriesLength",
    get: function get() {
      var r, e, o;
      return (o = (e = (r = this.chart) == null ? void 0 : r.series[0]) == null ? void 0 : e.data) == null ? void 0 : o.length;
    } /** Minimum size for the donut itself to be. */
  }, {
    key: "minimumDonutSize",
    get: function get() {
      return this.scale === b.JUMBO && !this.hideChartMetric ? a.minimumSizeJumbo : a.minimumSizeDefault;
    }
    /**
     * Setting Pie Chart related Configuration
     */
  }, {
    key: "localComponentOptions",
    get: function get() {
      var r = this.tooltipRef,
        e = this.figure,
        o = this.tooltipFormat;
      return y({
        plotOptions: {
          pie: {
            innerSize: "".concat(a.pieSizePercentage),
            dataLabels: !1,
            minSize: this.minimumDonutSize,
            point: {
              events: {
                mouseOver: function mouseOver() {
                  var t = this,
                    i = t.graphic.element.getBoundingClientRect(),
                    c = t.index;
                  var h = "";
                  o === d.VALUE ? h = t.series.yData[c] : h = "".concat(Math.round(t.series.yData[c]), "%"), r.tooltipData = [{
                    label: t.options.name,
                    value: h,
                    index: t.colorIndex
                  }], r.disableArrow = !0, r.targetRect = i, r.viewportRect = e.getBoundingClientRect(), r.isOpen = !0;
                },
                mouseOut: function mouseOut() {
                  r.isOpen = !1;
                }
              }
            }
          },
          series: {
            states: {
              hover: {
                halo: !1
              }
            }
          }
        },
        responsive: {
          rules: [{
            condition: {
              callback: function callback() {
                return window.innerWidth >= M.MEDIUM;
              }
            }
          }]
        },
        tooltip: {
          headerFormat: ""
        }
      });
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(l), "styles", this), E];
    }
  }]);
  return l;
}(v($));
l.tagName = a.beaconTagName;
n([p({
  attribute: a.attributes.metricTotal
})], l.prototype, "metricTotal", 2);
n([p({
  attribute: a.attributes.metricDescription
})], l.prototype, "metricDescription", 2);
n([p()], l.prototype, "scale", 2);
n([p({
  attribute: a.attributes.hideChartMetric,
  type: Boolean
})], l.prototype, "hideChartMetric", 2);
n([p({
  attribute: a.attributes.tooltipFormat
})], l.prototype, "tooltipFormat", 2);
n([m(".".concat(a.attributes.metricTotal))], l.prototype, "metricTotalElement", 2);
n([m(".".concat(a.attributes.metricDescription))], l.prototype, "metricDescriptionElement", 2);
n([m(".".concat(a.metricWrapperClass))], l.prototype, "metricWrapper", 2);
n([m("#chart-custom-tooltip")], l.prototype, "tooltipRef", 2);
n([m("figure.base")], l.prototype, "figure", 2);
export { l as BeaconDonutChart };